// client.js
// Client related reducers

/****************************************************************
 * Imports
 ****************************************************************/
import * as Action from '../actions/client';
import dotProp from 'dot-prop-immutable';
import InitialState from '../data/InitialState';

/****************************************************************
 * Initial State
 ****************************************************************/
const clientState = {
  ids: [],
  byId: {},
  nextId: 1,
}

/****************************************************************
 * Action Processors
 ****************************************************************/
// Processes CLIENT_ADD
function addClient (state, action) {
  var new_entry = {
    id: state.nextId,
    name: action.name,
  }

  var pos = state.ids.length;
  state = dotProp.set(state, `ids.${pos}`, new_entry.id);
  state = dotProp.set(state, `byId.${new_entry.id}`, new_entry);
  state = dotProp.set(state, 'nextId', state.nextId + 1);
  return state;
}

// Processes CLIENT_REMOVE
function removeClient (state, action) {
  state = dotProp.delete(state, `byId.${action.id}`);
  for(var i = state.ids.length - 1; i >= 0; i--) {
    if (state.ids[i] === action.id)
      return dotProp.delete(state, `ids.${i}`);
  }

  return state;
}

// Processes CLIENT_RENAME
function renameClient (state, action) {
  if (state.byId[action.id])
    return dotProp.set(state, `byId.${action.id}.name`, action.name);
  return state;
}

/****************************************************************
 * Reducers
 ****************************************************************/
// List Reducer
export function clientReducer (state, action) {
  if (state === undefined) {
    state = clientState;
    InitialState.GetClients().forEach((name) => {
      state = addClient(state, Action.addClient(name));
    });
  }

  switch (action.type) {
    case Action.CLIENT_ADD:
      return addClient(state, action);
    case Action.CLIENT_REMOVE:
      return removeClient(state, action);
    case Action.CLIENT_RENAME:
      return renameClient(state, action);
    default:
      return state;
  }
}

/****************************************************************
 * Exports
 ****************************************************************/
export default clientReducer;



// WEBPACK FOOTER //
// ./src/reducers/client.js